import { render, staticRenderFns } from "./BurgerButton.vue?vue&type=template&id=395ab093&scoped=true"
import script from "./BurgerButton.vue?vue&type=script&lang=js"
export * from "./BurgerButton.vue?vue&type=script&lang=js"
import style0 from "./BurgerButton.vue?vue&type=style&index=0&id=395ab093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ab093",
  null
  
)

export default component.exports